import { NumberDirection } from 'common-constants/numbers'

export const findNextIndex = <T>(
  direction: NumberDirection,
  selectedIndex: number,
  array: T[]
): number => {
  const leftBoundary = 0
  const rightBoundary = array.length - 1

  if (direction === NumberDirection.left) {
    // левая граница
    return selectedIndex - 1 >= leftBoundary ? selectedIndex - 1 : rightBoundary
  }

  if (direction === NumberDirection.right) {
    // правая граница
    return selectedIndex + 1 <= rightBoundary ? selectedIndex + 1 : leftBoundary
  }

  return 0 // не было продумано при разработке
}
